export default "__VITE_ASSET__ad2aa7b8__"